import templateUrl from 'emun.customer/customer-list-table.htm';
import basicController from 'servicestack/basic.controller.properties';
import resolve from 'ioc/resolve';
import modals from 'webmodals/modals';
import ServiceBus from 'servicestack/service-bus';
import customerConfig from "emun.customer/customer.config";
import orderConfig from "emun.order/order.config";
import labels from "emun.customer/_labels";
import activityConfig from "emun.activity/activity.config";

let component = {
	bindings: {
	},
	require: {
		container: '^customerContainer',
		list: '^customerList'
	},
	controller() {
		basicController(this);
		let $ctrl = this;
		$ctrl.bus = new ServiceBus();
		$ctrl.config = customerConfig;
		$ctrl.orderConfig = orderConfig;
		$ctrl.orderConfig = orderConfig;
		$ctrl.activityConfig = activityConfig;
		$ctrl.labels = labels;
		$ctrl.deleteCustomer = function (customer) {
			const $ctrl = this;
			return modals.confirm("Are you sure you want to delete customer ID: " + customer.id + " - Name: " + customer.companyName + "?", "Delete Customer").result.then(function () {
				$ctrl.bus.send('DeleteRetailer.json', customer).then(function (response) {
					$ctrl.$emit('RetailerDeleted', $ctrl);
					$ctrl.list.query.load();
				});
			});
		};
		$ctrl.startOrder = function (customer) {
			const $ctrl = this;
			$ctrl.$cart.createPrompt({
				retailer: customer,
				status: "Cart"
			});
		};
	},
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}

};

export default component;